export default "__VITE_ASSET__CSHvU79h__"